import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function AdminShell({ children, crumbs = [] }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh',
      background: 'var(--paper)', fontFamily: 'var(--sans)' }}>

      {/* Top bar */}
      <header style={{
        height: '48px', background: 'var(--ink)', color: 'var(--paper)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 24px', flexShrink: 0,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <Link to="/admin" style={{
            fontFamily: 'var(--serif)', fontSize: '18px',
            color: 'var(--paper)', textDecoration: 'none',
          }}>
            raji<span style={{ color: 'var(--amber)' }}>.</span>admin
          </Link>

          {/* Breadcrumbs */}
          {crumbs.length > 0 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {crumbs.map((crumb, i) => (
                <React.Fragment key={i}>
                  <span style={{ color: 'rgba(245,242,235,0.3)', fontSize: '13px' }}>›</span>
                  {crumb.href ? (
                    <Link to={crumb.href} style={{
                      fontSize: '12px', color: 'rgba(245,242,235,0.6)',
                      textDecoration: 'none',
                    }}>{crumb.label}</Link>
                  ) : (
                    <span style={{ fontSize: '12px',
                      color: 'rgba(245,242,235,0.9)' }}>{crumb.label}</span>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <span style={{ fontSize: '12px', color: 'rgba(245,242,235,0.5)' }}>
            {user?.email}
          </span>
          <Link to="/dashboard" style={{
            fontSize: '12px', color: 'rgba(245,242,235,0.6)',
            textDecoration: 'none', padding: '4px 10px',
            border: '1px solid rgba(245,242,235,0.2)', borderRadius: 'var(--r)',
          }}>← Dashboard</Link>
          <button onClick={() => { logout(); navigate('/'); }} style={{
            fontSize: '12px', color: 'var(--amber)', background: 'none',
            border: 'none', cursor: 'pointer', fontFamily: 'var(--sans)',
          }}>Sign out</button>
        </div>
      </header>

      {/* Page content */}
      <main style={{ flex: 1, overflowY: 'auto', padding: '32px 40px' }}>
        {children}
      </main>
    </div>
  );
}